import cn from 'classnames';
import { useEffect, useState } from 'react';

import { GroupCoaches, Group as IconGroup, Mark } from '@shared/assets';
import type { Group } from '@shared/types/common';
import { Card, IconButton } from '@shared/ui';

import * as st from './styles.module.scss';

type Props = {
	group: Group;
	removeFromSelectedGroups: (group: Group) => void;
	addSelectedToGroups: (group: Group) => void;
	isSelectedAtAnyGroups: (group: Group) => boolean;
};

export const CheckboxPublication: React.FC<Props> = ({
	group,
	removeFromSelectedGroups,
	addSelectedToGroups,
	isSelectedAtAnyGroups,
}) => {
	const onClick = () => {
		isSelectedAtAnyGroups(group) && removeFromSelectedGroups(group);
		!isSelectedAtAnyGroups(group) && addSelectedToGroups(group);
	};

	return (
		<Card className={st.card}>
			<div className={st.tag}>
				<IconButton
					size="small"
					className={cn(isSelectedAtAnyGroups(group) && st.tag__checked)}
					onClick={(event) => {
						event.preventDefault();
						onClick();
					}}
				>
					{isSelectedAtAnyGroups(group) && <Mark />}
				</IconButton>
				{typeof group.photo === 'string' ? (
					<img className={st.groupIcon} src={group.photo} alt={group.name} />
				) : (
					<div className={st.groupIcon}>
						{group.special_type === 'coaches' ? <GroupCoaches /> : <IconGroup />}{' '}
					</div>
				)}

				<div className={cn(st.tag__title)}>{group.name}</div>
			</div>
		</Card>
	);
};
